angular.module('admin')
  .controller('OfficesStreamCtrl', ['$scope', '$state','AgentService','HomeActivity','AccountService', 'HelperService', 'UtilService'
    , function($scope, $state, AgentService, HomeActivity, AccountService, helpers, utils){

      $scope.accountService = AccountService;


      $scope.getAllAgents = function(){
        var params = {};

        AgentService.getAll(params).then(
          function success(agents){
            $scope.agents = agents;
            $scope.getActivity();
          }, function error(err){
            utils.trackException('Get all offices error', err);
        });
      };

      $scope.getActivity = function(){
        var params = {filter:{include: ['agent', 'user'], where:{'agentId': {inq: _.pluck($scope.agents, 'id')}}}};
        
        HomeActivity.getAll(params).then(
          function success(activity){
            $scope.allActivity = activity;
          }, function error(err){
            utils.trackException('Get all offices error', err);
        });
      };

      $scope.getAllAgents();

  }]);
